import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createRegimeFromRegister = api((registerId, regimeId, type) =>
    mutate(
        gql`
            mutation CreateRegimeFromRegister($registerId: String!, $regimeId: String!, $type: RegimeType) {
                createRegimeFromRegister(id: $registerId, regimeId: $regimeId, type: $type)
            }
        `,
        { regimeId, registerId, type },
        { returns: "createRegimeFromRegister" }
    )
)
